// pages/Caravan.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function CaravanAMZ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="caravan-page">
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

        <style jsx>{`
          @media (max-width: 768px) {
            .caravan-page > div:nth-child(1) {
              padding: 60px 0 30px !important;
              min-height: 300px !important;
            }
            .caravan-page h1 {
              font-size: 2.5rem !important;
            }
            .caravan-page h3 {
              font-size: 1.5rem !important;
            }
          }
        `}</style>
      <img
src="/images/Asset4.png"
alt="Mapping Icon"
style={{
 width: '80px',
 height: '80px',
 objectFit: 'contain'
}}
/>
        <h1 style={{
          fontSize: '3.5rem',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          ⴰⴽⴰⴱⴰⵔ ⵏ ⵉⵣⵔⴼⴰⵏ ⵎⴰⴳⴰⵍ ⵜⵉⴽⵕⴹⵉ
        </h1>
        <p style={{
          fontSize: '1.3rem',
          lineHeight: '1.9',
          marginBottom: '25px',
          color: 'var(--text-light)'
        }}>
        ⴰⴽⴰⴱⴰⵕ ⴰⵏⴰⵎⵓⵔ ⵉⵎⵓⴷⴷⴰⵏ ⵙ ⵜⵎⵏⴰⴹⵉⵏ ⵙ 12 ⵏ ⵜⴳⵍⴷⵉⵜ ⵃⵎⴰ ⴰⴷ ⵉⵕⵥⵥ ⵓⴳⴰⴷⵉⵔ ⵏ ⵉⴼⵙⵙⵜⵉ
        </p>
        <div style={{
          background: 'var(--secondary-black)',
          padding: '20px 30px',
          borderRadius: '15px',
          borderRight: '4px solid var(--primary-orange)',
          marginBottom: '25px'
        }} style={{ direction: 'ltr' }}>
          <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
              <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>ⴰⵙⵙ ⵏ ⵓⵙⵙⵏⵜⵉ:</strong> ⴰⵙⵉⵏⴰⵙ 25 ⵏⵓⵡⴰⵏⴱⵉⵔ 2025
          </p>
          <p style={{ fontSize: '1.3rem' }}>
            <img src="/images/location.png" className="tab-icon3-img" /> <strong>ⵓⵟⵟⵓⵏ ⵏ ⵜⵖⵔⵎⵉⵡⵉⵏ:</strong> 12 ⵏ ⵜⵖⵔⵎⵜ
          </p>
        </div>
        </div>
      </div>

      {/* Main Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container" >


          {/* Mission & Objectives */}
          <div style={{ marginBottom: '60px' }} style={{ direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              ⵉⵡⵜⵜⴰⵙⵏ ⵏ ⵓⴽⴰⴱⴰⵕ
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              {[
                {
                  icon: '🤝',
                  title: 'ⴰⵏⵎⵓⵇⵇⴰⵔ ⴷ ⵓⵎⵢⴰⵖ',
                  desc: 'ⴰⵏⵎⵓⵇⵇⴰⵔ ⴷ ⵓⵎⵢⴰⵖ ⴰⴽⴷ ⵜⵉⵏⵎⵓⵔⵉⵢⵉⵏ ⴷ ⵉⵏⵎⵓⵔⴰⵏ ⵅⴼ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ'
                },
                {
                  icon: '👂',
                  title: 'ⴰⵙⵙⴼⵍⴷ ⴷ ⵓⴷⴳⴰⵔ',
                  desc: 'ⴰⵙⵙⴼⵍⴷ ⵉ ⵜⵏⵎⵓⵔⵉⵢⵉⵏ ⴷ ⵉⵏⵎⵓⵔⴰⵏ ⴷ ⵜⵓⵏⵊⵉⵎⵉⵏ ⵙⴳ ⵜⴽⵕⴹⵉ ⴷ ⵉ ⵜⵓⴳⴳⴰ ⵏⵏⵙⵏⵜ/ⵏⵏⵙⵏ ⵅⴼ ⵜⴽⵕⴹⵉ ⵜⴰⵎⵓⵟⵟⵓⵏⵜ ⵎⴳⴰⵍ ⵜⵉⵡⵜⵎⵉⵏ ⴷ ⵜⵔⴱⴰⵜⵉⵏ'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Cities Itinerary */}
          <div style={{ marginTop: '60px', marginBottom: '60px' }} style={{ direction: 'ltr'  }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '20px',
              textAlign: 'center',
              color: 'var(--white)'
            }} >
              🗺️ ⴰⵙⴰⴽⴰ ⵏ ⵓⴽⴰⴱⴰⵕ ⴳ ⵜⵎⵏⴰⴹⵉⵏ ⵏ ⵜⴳⵍⴷⵉⵜ
            </h3>
            <p style={{
              textAlign: 'center',
              fontSize: '1.2rem',
              marginBottom: '40px',
              color: 'var(--text-light)'
            }} >
            12 ⵏ ⵜⵎⵏⴰⴹⵜ | 16 ⵏ ⵡⴰⵙⵙ | ⵙⴳ ⵉⴼⴼⵓⵙ ⵏ ⵍⵎⵖⵔⵉⴱ ⵖⵔ ⵉⵥⵥⵍⵎⴹ ⵏⵏⵙ
            </p>

            <div style={{
              display: 'grid',
              gap: '20px'
            }}>
              {[
  { city: 'ⴷⴷⴰⵅⵍⴰ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⴷⴷⴰⵅⵍⴰ - ⵡⴰⴷⵉ ⴷⴷⴰⵀⴰⴱ', dates: '27 ⵏⵓⵡⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 1', icon: '/images/ville/Dakhla.png' },
  { city: 'ⵍⵄⵢⵓⵏ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵍⵄⵢⵓⵏ - ⵙⵙⴰⵇⵢⴰ ⵍⵃⵎⵔⴰ', dates: '29 ⵏⵓⵡⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 2', icon: '/images/ville/Laayoun.png' },
  { city: 'ⴳⵯⵍⵎⵉⵎ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⴳⵯⵍⵎⵉⵎ - ⵡⴰⴷ ⵏⵓⵏ', dates: '30 ⵏⵓⵡⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 3', icon: '/images/ville/Orientale.png' },
  { city: 'ⴰⴳⴰⴷⵉⵔ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵙⵓⵙ - ⵎⴰⵙⵙⴰ', dates: '1 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 4', icon: '/images/ville/Agadir.png' },
  { city: 'ⴱⵏⴳⵔⵉⵔ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵎⵕⵕⴰⴽⵛ - ⴰⵙⴼⵉ', dates: '2 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 5', icon: '/images/ville/Marrakech.png' },
  { city: 'ⵡⴰⵔⵣⴰⵣⴰⵜ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⴷⵔⴰ - ⵜⴰⴼⵉⵍⴰⵍⵜ', dates: '3 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 6', icon: '/images/ville/Tafilalt.png' },
  { city: 'ⴱⵏⵉ ⵎⵍⵍⴰⵍ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⴱⵏⵉ ⵎⵍⵍⴰⵍ - ⵅⵏⵉⴼⵕⴰ', dates: '5 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 7', icon: '/images/ville/Benimellal.png' },
  { city: 'ⵜⵉⴳⵎⵎⵉ ⵜⵓⵎⵍⵉⵍⵜ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵜⴳⵎⵎⵉ ⵜⵓⵎⵍⵉⵍⵜ - ⵙⵟⵟⴰⵜ', dates: '6 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 8', icon: '/images/ville/Casa.png' },
  { city: 'ⴰⴼⴰⵙ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⴼⴰⵙ - ⵎⴽⵏⴰⵙ', dates: '7 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 9', icon: '/images/ville/Meknes.png' },
  { city: 'ⵡⵊⴷⴰ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵓⴳⵎⵎⵓⴹ', dates: '8 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 10', icon: '/images/ville/Orientale.png' },
  { city: 'ⵍⵃⵓⵙⵉⵎⴰ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵟⴰⵏⵊⴰ - ⵜⵉⵟⵡⴰⵏ - ⵍⵃⵓⵙⵉⵎⴰ', dates: '9 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 11', icon: '/images/ville/Tanger.png' },
  { city: 'ⵍⵇⵏⵉⵟⵕⴰ', region: 'ⵜⴰⵎⵏⴰⴹⵜ ⵏ ⵕⵕⴱⴰⵟ - ⵙⵍⴰ - ⵍⵇⵏⵉⵟⵕⴰ', dates: '10 ⴷⵓⵊⴰⵏⴱⵉⵔ', day: 'ⴰⵙⵔⵙ 12', icon: '/images/ville/Rabat.png' }
].map((stop, index) => (
                <div key={index} className="city-card" style={{
                  background: index % 2 === 0 ? 'var(--primary-black)' : 'var(--secondary-black)',
                  padding: '25px 30px',
                  borderRadius: '15px',
                  border: '2px solid rgba(255, 107, 53, 0.3)',
                  display: 'grid',
                  gridTemplateColumns: '80px 1fr 200px 150px',
                  alignItems: 'center',
                  gap: '20px',
                  transition: 'all 0.3s ease'
                }}>
                  <div className="city-icon" style={{
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <img
                      src={stop.icon}
                      alt={stop.city}
                      style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'contain'
                      }}
                    />
                  </div>

                  <div className="city-info">
                    <h4 style={{
                      fontSize: '1.5rem',
       marginBottom: '5px',
       color: 'var(--primary-orange)',
       fontWeight: '700',
       textAlignLast: 'left'
                    }}>
                      {stop.city}
                    </h4>
                    <p style={{
                      fontSize: '1.1rem',
                      color: 'var(--text-light)',
                         textAlignLast: 'left'
                    }}>
                      {stop.region}
                    </p>
                  </div>

                  <div className="city-date" style={{
                    background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                    padding: '12px 20px',
                    borderRadius: '10px',
                    textAlign: 'center',
                    fontWeight: '700',
                    fontSize: '1.1rem'
                  }}>
                    {stop.dates}
                  </div>

                  <div className="city-day" style={{
                    textAlign: 'center',
                    fontSize: '1rem',
                    color: 'var(--text-light)',
                    fontWeight: '600'
                  }}>
                    {stop.day}
                  </div>
                </div>
              ))}
            </div>

            {/* Responsive Styles */}
            <style jsx>{`
              @media (max-width: 768px) {
                .city-card {
                  grid-template-columns: 1fr !important;
                  padding: 20px 15px !important;
                  gap: 15px !important;
                  text-align: center;
                }

                .city-icon {
                  margin-bottom: 10px;
                }

                .city-icon img {
                  width: 50px !important;
                  height: 50px !important;
                }

                .city-info {
                  text-align: center !important;
                }

                .city-info h4 {
                  font-size: 1.3rem !important;
                  margin-bottom: 8px !important;
                  text-align-last: center !important;
                }

                .city-info p {
                  font-size: 1rem !important;
                  line-height: 1.5;
                  text-align-last: center !important;
                }

                .city-date {
                  margin: 10px auto !important;
                  max-width: 200px;
                  padding: 10px 15px !important;
                  font-size: 1rem !important;
                }

                .city-day {
                  font-size: 0.95rem !important;
                  padding-top: 5px;
                }
              }

              @media (max-width: 480px) {
                .city-card {
                  padding: 15px 10px !important;
                }

                .city-info h4 {
                  font-size: 1.2rem !important;
                }

                .city-info p {
                  font-size: 0.95rem !important;
                }

                .city-date {
                  font-size: 0.95rem !important;
                  padding: 8px 12px !important;
                }
              }
            `}</style>
          </div>

          <div className="section-separator"></div>




          {/* Call to Action */}
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)'
            }}>
              ⴰⵏⵙⵓⴼ ⵙ ⵓⴷⵔⴰⵡ ⵏⵏⵓⵏⵜ/ⵏⵏⵓⵏ ⴳ ⵓⵎⵓⴷⴷⵓ ⴰⴷ
            </h3>
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '30px',
              color: 'var(--text-light)',
              lineHeight: '1.8'
            }}>
              ⴰⵏⵙⵓⴼ ⵙⵉⵜⵓⵏⵜ/ⵙⵉⵜⵓⵏ ⴳ ⵉⵙⵔⴰⵙ ⵏ ⵓⴽⴰⴱⴰⵕ ⵙ 12
            </p>



            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic'
            }}>
              ⴰⵔ ⴽⵯⵏⵜ/ⴽⵯⵏ ⵏⵜⵜⴳⴰⵏⵏⴰ ⵃⵎⴰ ⴰⴷ ⵏⵙⵙⴼⵍⴷ ⵉ ⵜⵙⵓⵎⴰⵔ ⵏⵏⴽⵯⵏⵜ/ⵏⵏⵓⵏ ⴷ ⵉⵎⵏⴰⴷⵏ ⵏⵏⴽⵯⵏⵜ/ⵏⵏⵓⵏⵜ
            </p>
          </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default CaravanAMZ;
